<template>
  <section class="footer">
    <div class="container">
      <div class="footer-left">
        <div class="tel-title">全国免费咨询热线</div>
        <div class="tel-num">19950256252</div>
        <div class="tel-intro">周一到周日 9:00 ~ 18:00</div>
      </div>
      <div class="footer-middle">
        <div class="footer-nav">
          <div class="footer-nav-item"><a href="">关于我们</a></div>
          <div class="footer-nav-item"><a href="">联系我们</a></div>
          <div class="footer-nav-item"><a href="">用户服务协议和隐私政策</a></div>
          <div class="footer-nav-item"><a href="">选课中心</a></div>
        </div>
        <div class="footer-copyright">
          Copyright © 2020-2025 四川清瀚致远教育咨询有限公司 版权所有
        </div>
        <div class="footer-icp">
          <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2025162808号-1</a>
        </div>
        <div class="footer-icons">
          <a id="_pingansec_bottomimagesmall_shiming" target="_blank"
             href="//si.trustutn.org/info?sn=880210205040298435364&certType=1">
            <img src="//v.trustutn.org/images/cert/realname_small_img.png" alt=""/></a>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-image-item">
          <div class="footer-image-title">微信公众号</div>
          <img src="../../static/images/gzh.jpg" alt="清瀚学堂" class="footer-image">
        </div>
        <div class="footer-image-item">
          <div class="footer-image-title">微信小程序</div>
          <img src="../../static/images/xcx.jpg" alt="清瀚学堂" class="footer-image">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TheFooter"
}
</script>

<style scoped>
.footer {
  background-color: #2a363c;
  color: #ffffff;
  padding: 40px 0;
}

.footer .container {
  display: flex;
  justify-content: space-between;
  align-content: center;
}

.tel-title {
  font-size: 18px;
  margin-top: 20px;
}

.tel-num {
  font-size: 28px;
  margin-top: 20px;
}

.tel-intro {
  margin-top: 6px;
  font-size: 14px;
  color: #9b9b9b;
}

.footer-left {
  padding-right: 50px;
  border-right: 1px #666 dashed;
}

.footer-nav {
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-top: 20px;
}

.footer-nav-item {
  padding: 0 10px;
  border-right: 1px solid #666;
}

.footer-nav-item a {
  color: #888;
  font-size: 15px;
}

.footer-nav-item:first-child {
  padding-left: 0;
}

.footer-nav-item:last-child {
  border-right: 0;
}

.footer-image-item {
  text-align: center;
  margin-left: 20px;
}

.footer-right {
  display: flex;
  justify-content: space-between;
}

.footer-image {
  width: 100px;
  height: 100px;
  border-radius: 3px;
  margin-top: 10px;
}

.footer-copyright {
  margin-top: 30px;
  color: #888;
  font-size: 14px;
}

.footer-icp {
  margin-top: 20px;
  font-size: 14px;
  position: relative;
}

.footer-icp a {
  color: #888;
}

.footer-middle {
  position: relative;
}

.footer-icons {
  position: absolute;
  bottom: -10px;
  right: 0;
}
</style>
